<template>
  <div class="personal" ref="top">
    <div class="nav">
      <div class="container personalContainer">
        <router-link to="" class="navItem">消息</router-link>
        <router-link to="" class="navItem navActive">个人资料</router-link>
        <router-link to="" class="navItem">作品</router-link>
        <router-link to="" class="navItem">竞赛</router-link>
        <router-link to="" class="navItem">
          <Dropdown>
            <Icon type="md-person" />
            <DropdownMenu slot="list">
              <DropdownItem><span class="menuItem" @click="changePwd">修改密码</span></DropdownItem>
              <DropdownItem><span class="menuItem" @click="logOut">退出登录</span></DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </router-link>
      </div>
    </div>
    <div class="sideNav myBar">
      <span @click="goAnchor(1)" class="sideNavItem nav1" 
        :class="{
          'nav1Active sideNavItemActive': navActiveId==1, 
          'value5': percentBasic!=0,
          'value4': percentBasic>60&&percentBasic<=99,
          'value3': percentBasic>40&&percentBasic<=60,
          'value2': percentBasic>20&&percentBasic<=40,
          'value1': percentBasic>0&&percentBasic<=20}"></span>
      <span @click="goAnchor(2)" class="sideNavItem nav2" 
        :class="{'nav2Active sideNavItemActive': navActiveId==2, 'value5': isValueArr(educationInfo)}"></span>
      <span @click="goAnchor(3)" class="sideNavItem nav3" 
        :class="{'nav3Active sideNavItemActive': navActiveId==3, 'value5': isValueArr(awardInfo)}"></span>
      <span @click="goAnchor(4)" class="sideNavItem nav4" 
        :class="{'nav4Active sideNavItemActive': navActiveId==4, 'value5': isValueArr(experienceInfo)}"></span>
      <span @click="goAnchor(5)" class="sideNavItem nav5" 
        :class="{'nav5Active sideNavItemActive': navActiveId==5, 'value5': isValueArr(workInfo)}"></span>
      <span @click="goAnchor(6)" class="sideNavItem nav6" 
        :class="{'nav6Active sideNavItemActive': navActiveId==6, 'value5': isValueArr(paperInfo)}"></span>
      <span @click="goAnchor(7)" class="sideNavItem nav7" 
        :class="{'nav7Active sideNavItemActive': navActiveId==7, 'value5': isValueArr(qualificationInfo)}"></span>
      <span @click="goAnchor(8)" class="sideNavItem nav8" 
        :class="{'nav8Active sideNavItemActive': navActiveId==8, 'value5': isValueArr(mediaInfo)}"></span>
      <span @click="goAnchor(9)" class="sideNavItem nav9" 
        :class="{'nav9Active sideNavItemActive': navActiveId==9, 'value5': isValueArr(serviceInfo)}"></span>
      <span @click="goAnchor(10)" class="sideNavItem nav10" 
        :class="{'nav10Active sideNavItemActive': navActiveId==10, 'value5': isValueArr(activityInfo)}"></span>
      <span @click="goAnchor('top')" class="top"></span>
    </div>

    <div class="container personalContainer">
      <div class="basicWrap" v-if="userInfo.id">
        <div>
          <div class="txWrap">
            <img v-if="userInfo.avatar" class="avatarImg" :src="getImageUrl(userInfo.avatar,'avatar')" alt="">
            <span class="changeTxBtn" @click="edit('avatar')"><Icon type="md-sync" /></span>
          </div>
          <div class="basicEdit edit" @click="edit('majorInfo')">编辑</div>
          <p class="bold realName">{{userInfo.trueName}}</p>  
        </div>
        <p>{{userInfo.professionName}}
          <template v-if="userInfo.otherProfessionName">/ <span
            v-for="(n, i) in userInfo.otherProfessionName.split(',')" 
            :key="i">{{n}}<template v-if="i+1!=userInfo.otherProfessionName.split(',').length"> / </template></span></template></p>
        <p v-if="userInfo.industryName"><span 
          class="registerLabel" 
          v-for="(n, i) in userInfo.industryName.split(',')" 
          :key="i">{{n}}</span></p>
      </div>
      <div ref="1" class="itemWrap">
        <div class="itemTitle">
          <h4>个人基本信息</h4>
          <template v-if="isValueObj(basicInfo)">
            <span v-if="isDetail!=1" class="titleBtn folder" @click="showDetail(1)">展开</span>
            <span v-if="isDetail==1" class="titleBtn edit" @click="edit('basicInfo')">编辑</span>
          </template>
        </div>
        <div class="itemInfo" v-if="isDetail==1 || !isValueObj(basicInfo)">
          <Row v-if="isDetail==1&&isValueObj(basicInfo)" :gutter="15">
            <Col :lg="8" :xs="12">
              <p class="label">性别</p>
              <p>{{userInfo.sex}}</p>
            </Col>
            <Col :lg="8" :xs="12">
              <p class="label">生日</p>
              <p>{{userInfo.birthDay}}</p>
            </Col>
            <Col :lg="8" :xs="24">
              <p class="label">民族</p>
              <p>{{userInfo.nation}}</p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">
                通讯地址
                <span class="labelSwitch">
                  <span>对外展示</span>
                  <i-switch 
                    class="switchBtn" 
                    true-color="#00b7ee" 
                    size="small" 
                    :loading="addressLoading"
                    :before-change="beforeChangeAddress"
                    v-model="userInfo.addressOpen" />
                </span>
              </p>
              <p>{{userInfo.address}}</p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">
                电子邮箱
                <span class="labelSwitch">
                  <span>对外展示</span>
                  <i-switch 
                    class="switchBtn" 
                    true-color="#00b7ee" 
                    size="small" 
                    :loading="emailLoading"
                    :before-change="beforeChangeEmail"
                    v-model="userInfo.emailOpen" />
                </span>
              </p>
              <p>{{userInfo.email}}</p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">
                联系电话
                <span class="labelSwitch">
                  <span>对外展示</span>
                  <i-switch 
                    class="switchBtn" 
                    true-color="#00b7ee" 
                    size="small" 
                    :loading="phoneLoading"
                    :before-change="beforeChangePhone"
                    v-model="userInfo.phoneOpen" />
                </span>
              </p>
              <p>
                <span>{{userInfo.mobilePhone}}</span>
                <Tooltip placement="bottom" theme="light">
                  <span style="margin-left:10px; font-size:18px; line-height:18px">...</span>
                  <template slot="content">
                    <template v-for="(p, i) in userInfo.phone">
                      <p v-if="i!=0" :key="i">{{p.phone}}</p>
                    </template>
                  </template>
                </Tooltip>
              </p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">主页/官网</p>
              <p>{{userInfo.website}}</p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">微信号/公众号</p>
              <p>{{userInfo.wechatSubscription}}</p>
            </Col>
            <Col :lg="8" :sm="12" :xs="24">
              <p class="label">
                微博
                <span class="labelSwitch">
                  <span>对外展示</span>
                  <i-switch 
                    class="switchBtn" 
                    true-color="#00b7ee" 
                    size="small" 
                    :loading="weiboLoading"
                    :before-change="beforeChangeWeibo"
                    v-model="userInfo.weiboOpen" />
                </span>
              </p>
              <p>{{userInfo.weibo}}</p>
            </Col>
            <Col span="24">
              <p class="label">视频</p>
              <p>{{userInfo.video}}<span v-if="userInfo.video" class="stateNote">{{getStatusText(userInfo.videoStatus)}}</span></p>
            </Col>
            <Col span="24">
              <p class="label">个人简介/理念</p>
              <p>{{userInfo.description}}</p>
            </Col>
          </Row>
          <div v-if="!isValueObj(basicInfo)" class="addArea">
            <span class="addBtn" @click="edit('basicInfo')">添加个人基本信息</span>
          </div>
        </div>
      </div>
      <div ref="2" class="itemWrap">
        <div class="itemTitle">
          <h4>高等教育背景</h4>
          <span class="titleBtn" v-if="isValueArr(educationInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="educationLoading"
              :before-change="beforeChangeEducation"
              v-model="userInfo.educationOpen" />
            <span v-if="isDetail!=2" class="folder" @click="showDetail(2)">展开</span>
            <span v-if="isDetail==2" class="edit" @click="edit('educationInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==2 || !isValueArr(educationInfo)">
          <div v-if="isDetail==2&&isValueArr(educationInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(d, i) in educationInfo" :key="d.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">毕业院校</p>
                  <p class="content">{{d.university}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">学历</p>
                  <p class="content">{{getEducationText(d.education)}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">毕业年份</p>
                  <p class="content">{{d.year}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">所学专业</p>
                  <p class="content">{{d.major}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">所在班级</p>
                  <p class="content">{{d.classGrade || '-'}}</p>
                </Col>
                <Col :lg="8" :sm="12" :xs="12">
                  <p class="label">导师</p>
                  <p class="content">{{d.tutor || '-'}}</p>
                </Col>
                <Col span="24">
                  <p class="label">学历证明</p>
                </Col>
                <Col v-if="d.certificate" span="24" class="modalFormWrap">
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(d.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(d.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(d.status)}}</span></p>
                </Col>
              </Row> 
              
              <div class="editBtn-div">
                <span v-if="isDetail==2" class="delete" @click="deleteEducation(d)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(educationInfo)" class="addArea">
            <span class="addBtn" @click="edit('educationInfo')">添加高等教育背景</span>
          </div>
        </div>
      </div>
      <div ref="3" class="itemWrap">
        <div class="itemTitle">
          <h4>奖项荣誉</h4>
          <span class="titleBtn" v-if="isValueArr(awardInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="awardLoading"
              :before-change="beforeChangeAward"
              v-model="userInfo.awardsOpen" />
            <span v-if="isDetail!=3" class="folder" @click="showDetail(3)">展开</span>
            <span v-if="isDetail==3" class="edit" @click="edit('awardInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==3 || !isValueArr(awardInfo)">
          <div v-if="isDetail==3 && isValueArr(awardInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(h, i) in awardInfo" :key="h.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">获奖时间</p>
                  <p class="content">{{h.year}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">获奖作品名称</p>
                  <p class="content">{{h.projectName}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">奖项名称</p>
                  <p class="content">{{h.awardName}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">授奖部门</p>
                  <p class="content">{{h.awardDepartment}}</p>
                </Col>
                <Col span="24">
                  <p class="label">获奖证明</p>
                </Col>
                <Col v-if="h.certificate" span="24" class="modalFormWrap">
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(h.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(h.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(h.status)}}</span></p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==3" class="delete" @click="deleteAward(h)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(awardInfo)" class="addArea">
            <span class="addBtn" @click="edit('awardInfo')">添加奖项荣誉</span>
          </div>
        </div>
      </div>
      <div ref="4" class="itemWrap">
        <div class="itemTitle">
          <h4>工作履历</h4>
          <span class="titleBtn" v-if="isValueArr(experienceInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="experienceLoading"
              :before-change="beforeChangeExperience"
              v-model="userInfo.workOpen" />
            <span v-if="isDetail!=4" class="folder" @click="showDetail(4)">展开</span>
            <span v-if="isDetail==4" class="edit" @click="edit('experienceInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==4 || !isValueArr(experienceInfo)">
          <div v-if="isDetail==4 && isValueArr(experienceInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(e, i) in experienceInfo" :key="e.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">工作起止时间</p>
                  <p class="content">{{e.startYear}}-<span v-if="e.endYear">{{e.endYear}}</span><span v-else>至今</span></p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">工作机构</p>
                  <p class="content">{{e.company}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">职位</p>
                  <p class="content">{{e.job}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">证明人姓名</p>
                  <p class="content">{{e.witnessName || '-'}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">证明人手机</p>
                  <p class="content">{{e.witnessPhone || '-'}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">我是证明人的</p>
                  <p class="content">{{getWorkRelationText(e.witnessRelation)}}</p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==4" class="delete" @click="deleteExperience(e)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(experienceInfo)" class="addArea">
            <span class="addBtn" @click="edit('experienceInfo')">添加工作履历</span>
          </div>
        </div>
      </div>
      <div ref="5" class="itemWrap">
        <div class="itemTitle">
          <h4>代表作品</h4>
          <span class="titleBtn" v-if="isValueArr(workInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="projectLoading"
              :before-change="beforeChangeProject"
              v-model="userInfo.projectOpen" />
            <span v-if="isDetail!=5" class="folder" @click="showDetail(5)">展开</span>
            <!-- <span v-if="isDetail==5" class="edit" @click="edit('workInfo')">编辑</span> -->
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==5 || !isValueArr(workInfo)">
          <div :class="{itemDivider: i!=0}" v-for="(w, i) in workInfo" :key="w.id">
            <Row v-if="isDetail==5&&isValueArr(workInfo)" :gutter="15">
              <Col :lg="8" :xs="12">
                <p class="label">作品名称</p>
                <p class="content">{{w.name}}</p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">作品类型</p>
                <p class="content">{{w.designTypeName}}</p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">完成时间</p>
                <p class="content">{{w.completionDate}}</p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">版权所有方</p>
                <p class="content">{{getCopyrightText(w.copyright)}}<span v-if="w.copyrightOwner && w.copyright != 'SELF'">：{{w.copyrightOwner}}</span></p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">项目地点</p>
                <p class="content">{{w.locationNames}}</p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">项目金额</p>
                <p class="content">{{w.price || '-'}}<span v-if="w.price">万元</span></p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">设计形式</p>
                <p class="content">{{getTeamTypeText(w.teamType)}}</p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">主创人员</p>
                <p class="content">
                  <span v-if="w.authorSelf">{{userInfo.trueName}} </span><span v-if="w.author">{{w.author}}</span>
                  <span v-if="!w.authorSelf && !w.author && !w.participantSelf && !w.participant">{{userInfo.trueName}}</span>
                </p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">参与人员</p>
                <p class="content"><span v-if="w.participantSelf">{{userInfo.trueName}} </span>{{w.participant}}<span v-if="!w.participantSelf&&!w.participant">-</span></p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">专利号</p>
                <p class="content">{{w.patentNumber || '-'}}<span v-if="w.patentNumber" class="stateNote">{{getStatusText(w.patentNumberStatus)}}</span></p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">著作权证书号</p>
                <p class="content">{{w.certificateNumber || '-'}}<span v-if="w.certificateNumber" class="stateNote">{{getStatusText(w.certificateNumberStatus)}}</span></p>
              </Col>
              <Col :lg="8" :xs="12">
                <p class="label">关联作品</p>
                <p class="content">{{w.relationProject || '-'}}</p>
              </Col>
              <Col span="24">
                <p class="label">作品说明</p>
                <p class="content">{{w.description}}</p>
              </Col>
              <Col span="24" class="modalFormWrap">
                <p class="label">作品图片</p>
                <div class="imgWrap" v-for="p in w.pictures" :key="p.id">
                  <img class="img" :src="getImageUrl(p.path,'avatar')" alt="">
                  <div class="imgMask">
                    <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(p.path))" />
                  </div>
                </div>
              </Col>
            </Row>
            <div class="editBtn-div">
              <span v-if="isDetail==5" class="edit" @click="edit('workInfo', w)">编辑</span>
              <span v-if="isDetail==5" class="delete" @click="deleteWork(w)"><Icon type="ios-trash-outline" size="18" />删除</span>
            </div>
          </div>
          <div class="addArea" :class="{itemDivider: isValueArr(workInfo)}">
            <span class="addBtn" @click="edit('workInfo')">添加代表作品</span>
          </div>
          <!-- <div v-if="!isValueArr(workInfo)" class="addArea">
            <span class="addBtn" @click="edit('workInfo')">添加代表作品</span>
          </div> -->
        </div>
      </div>
      <div ref="6" class="itemWrap">
        <div class="itemTitle">
          <h4>论文著作</h4>
          <span class="titleBtn" v-if="isValueArr(paperInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="paperLoading"
              :before-change="beforeChangePaper"
              v-model="userInfo.publicationOpen" />
            <span v-if="isDetail!=6" class="folder" @click="showDetail(6)">展开</span>
            <span v-if="isDetail==6" class="edit" @click="edit('paperInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==6 || !isValueArr(paperInfo)">
          <div v-if="isDetail==6 && isValueArr(paperInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(p, i) in paperInfo" :key="p.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">发表时间</p>
                  <p class="content">{{p.year}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">著作全称</p>
                  <p class="content">{{p.title}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">刊登刊物/出版社</p>
                  <p class="content">{{p.publisher}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">第一作者</p>
                  <p class="content">
                    <span v-if="p.authorSelf">{{userInfo.trueName}} </span><span v-if="p.author">{{p.author}}</span>
                    <span v-if="!p.authorSelf && !p.author && !p.participantSelf && !p.participant">{{userInfo.trueName}}</span>
                  </p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">其他作者</p>
                  <p class="content"><span v-if="p.participantSelf">{{userInfo.trueName}} </span>{{p.participant}}<span v-if="!p.participantSelf&&!p.participant">-</span></p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">著作权证书号</p>
                  <p class="content">{{p.certificateNumber || '-'}}<span v-if="p.certificateNumber" class="stateNote">{{getStatusText(p.status)}}</span></p>
                </Col>
                <template v-if="p.certificate">
                  <Col span="24" class="modalFormWrap">
                    <p class="label">刊登/出版证明</p>
                    <div class="imgWrap">
                      <img class="img" :src="getImageUrl(p.certificate, 'avatar')" alt="">
                      <div class="imgMask">
                        <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(p.certificate))" />
                      </div>
                    </div>
                  </Col>
                </template>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==6" class="delete" @click="deletePaper(p)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(paperInfo)" class="addArea">
            <span class="addBtn" @click="edit('paperInfo')">添加论文著作</span>
          </div>
        </div>
      </div>
      <div ref="7" class="itemWrap">
        <div class="itemTitle">
          <h4>专业资质</h4>
          <span class="titleBtn" v-if="isValueArr(qualificationInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="qualificationLoading"
              :before-change="beforeChangeQualification"
              v-model="userInfo.qualificationOpen" />
            <span v-if="isDetail!=7" class="folder" @click="showDetail(7)">展开</span>
            <span v-if="isDetail==7" class="edit" @click="edit('qualificationInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==7 || !isValueArr(qualificationInfo)">
          <div v-if="isDetail==7 && isValueArr(qualificationInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(q, i) in qualificationInfo" :key="q.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">资质名称</p>
                  <p class="content">{{q.name}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">资质有效期</p>
                  <p class="content">{{q.endYear}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">颁发部门</p>
                  <p class="content">{{q.department}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">颁发国家</p>
                  <p class="content">{{q.country}}</p>
                </Col>
                <Col v-if="q.certificate" span="24" class="modalFormWrap">
                  <p class="label">资质证明</p>
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(q.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(q.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(q.status)}}</span></p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==7" class="delete" @click="deleteQualification(q)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(qualificationInfo)" class="addArea">
            <span class="addBtn" @click="edit('qualificationInfo')">添加专业资质</span>
          </div>
        </div>
      </div>
      <div ref="8" class="itemWrap">
        <div class="itemTitle">
          <h4>媒体曝光</h4>
          <span class="titleBtn" v-if="isValueArr(mediaInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="mediaLoading"
              :before-change="beforeChangeMedia"
              v-model="userInfo.mediaOpen" />
            <span v-if="isDetail!=8" class="folder" @click="showDetail(8)">展开</span>
            <span v-if="isDetail==8" class="edit" @click="edit('mediaInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==8 || !isValueArr(mediaInfo)">
          <div v-if="isDetail==8 && isValueArr(mediaInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(m, i) in mediaInfo" :key="m.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">媒体名称</p>
                  <p class="content">{{m.mediaName}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">媒体国家</p>
                  <p class="content">{{m.country || '-'}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">报道时间</p>
                  <p class="content">{{m.year}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">报道标题</p>
                  <p class="content">{{m.title}}</p>
                </Col>
                <Col :lg="8" :sm="12" :xs="24">
                  <p class="label">相关链接</p>
                  <p class="content">{{m.url || '-'}}<span v-if="m.url" class="stateNote">{{getStatusText(m.urlStatus)}}</span></p>
                </Col>
                <Col v-if="m.certificate" span="24" class="modalFormWrap">
                  <p class="label">报道证明</p>
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(m.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(m.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(m.status)}}</span></p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==8" class="delete" @click="deleteMedia(m)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(mediaInfo)" class="addArea">
            <span class="addBtn" @click="edit('mediaInfo')">添加媒体曝光</span>
          </div>
        </div>
      </div>
      <div ref="9" class="itemWrap">
        <div class="itemTitle">
          <h4>社会任职</h4>
          <span class="titleBtn" v-if="isValueArr(serviceInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="serviceLoading"
              :before-change="beforeChangeService"
              v-model="userInfo.serviceOpen" />
            <span v-if="isDetail!=9" class="folder" @click="showDetail(9)">展开</span>
            <span v-if="isDetail==9" class="edit" @click="edit('serviceInfo')">编辑</span>
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==9 || !isValueArr(serviceInfo)">
          <div v-if="isDetail==9 && isValueArr(serviceInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(s, i) in serviceInfo" :key="s.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">任职机构名称</p>
                  <p class="content">{{s.organizationName}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">机构所在国家</p>
                  <p class="content">{{s.country || '-'}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">担任职务</p>
                  <p class="content">{{s.job}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">任职开始时间</p>
                  <p class="content">{{s.startYear}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">任职结束时间</p>
                  <p class="content">{{s.endYear}}</p>
                </Col>
                <Col :lg="8" :sm="12" :xs="24">
                  <p class="label">相关链接</p>
                  <p class="content">{{s.url || '-'}}<span v-if="s.url" class="stateNote">{{getStatusText(s.urlStatus)}}</span></p>
                </Col>
                <Col v-if="s.certificate" span="24" class="modalFormWrap">
                  <p class="label">报道证明</p>
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(s.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(s.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(s.status)}}</span></p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==9" class="delete" @click="deleteService(s)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>
          <div v-if="!isValueArr(serviceInfo)" class="addArea">
            <span class="addBtn" @click="edit('serviceInfo')">添加社会任职</span>
          </div>
        </div>
      </div>
      <div ref="10" class="itemWrap">
        <div class="itemTitle">
          <h4>社会活动</h4>
          <span class="titleBtn" v-if="isValueArr(activityInfo)">
            <span class="switchText">对外展示</span>
            <i-switch 
              class="switchBtn" 
              true-color="#00b7ee" 
              size="small" 
              :loading="activityLoading"
              :before-change="beforeChangeActivity"
              v-model="userInfo.activityOpen" />
            <span v-if="isDetail!=10" class="folder" @click="showDetail(10)">展开</span>
            <!-- <span v-if="isDetail==10" class="edit" @click="edit('activityInfo')">编辑</span> -->
          </span>
        </div>
        <div class="itemInfo" v-if="isDetail==10 || !isValueArr(activityInfo)">
          <div v-if="isDetail==10 && isValueArr(activityInfo)">
            <div :class="{itemDivider: i!=0}" v-for="(t, i) in activityInfo" :key="t.id">
              <Row :gutter="15">
                <Col :lg="8" :xs="12">
                  <p class="label">活动名称</p>
                  <p class="content">{{t.name}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">活动主办机构</p>
                  <p class="content">{{t.organizer}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">担任职务</p>
                  <p class="content">{{t.job}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">其他职务</p>
                  <p class="content">{{t.otherJob || '-'}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">活动所在地</p>
                  <p class="content">{{t.locationNames}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">活动时间</p>
                  <p class="content">{{t.date}}</p>
                </Col>
                <Col :lg="8" :xs="12">
                  <p class="label">活动类型</p>
                  <p class="content">{{t.activityType || '-'}}</p>
                </Col>
                <Col :lg="8" :sm="12" :xs="24">
                  <p class="label">相关链接</p>
                  <p class="content">{{t.url || '-'}}<span v-if="t.url" class="stateNote">{{getStatusText(t.urlStatus)}}</span></p>
                </Col>
                <Col v-if="t.certificate" span="24" class="modalFormWrap">
                  <p class="label">报道证明</p>
                  <div class="imgWrap">
                    <img class="img" :src="getImageUrl(t.certificate, 'avatar')" alt="">
                    <div class="imgMask">
                      <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(t.certificate))" />
                    </div>
                  </div>
                  <p><span class="stateNote">{{getStatusText(t.status)}}</span></p>
                </Col>
              </Row>
              <div class="editBtn-div">
                <span v-if="isDetail==10" class="edit" @click="edit('activityInfo', t)">编辑</span>
                <span v-if="isDetail==10" class="delete" @click="deleteActivity(t)"><Icon type="ios-trash-outline" size="18" />删除</span>
              </div> 
            </div>
          </div>

          <div class="addArea" :class="{itemDivider: isValueArr(activityInfo)}">
            <span class="addBtn" @click="edit('activityInfo')">添加社会活动</span>
          </div>
          <!-- <div v-if="!isValueArr(activityInfo)" class="addArea">
            <span class="addBtn" @click="edit('activityInfo')">添加社会活动</span>
          </div> -->
        </div>
      </div>
    </div>
    
    <!-- 底部全部个人资料信息完成度信息 -->
    <div v-if="percentTotal>0" class="fixedBottom">
      <Tooltip :content="`资料完善度${percentTotal}%`" theme="light" style="width: 100%">
        <Progress :percent="percentTotal" :hide-info="true" :stroke-color="['#6281e8', '#cf479e']" />
      </Tooltip>
    </div>

    <!-- 查看大图 -->
    <Modal v-model="largeImg"
      title="图片信息"
      :footer-hide="true">
      <LargeImg :img="img"/>
    </Modal>

    <Modal v-model="showLargePic"
      title="查看图片" 
      :footer-hide="true"
      :styles="{top: '50px'}"
      width=640>
      <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
    </Modal>
    <!-- 头像信息 -->
    <Modal v-model="avatarEdit"
      title="编辑真实头像"
      :mask-closable="false"
      :footer-hide="true"
      :closable="userInfo.avatar?true:false"
      class-name="myModal"
      width="520">
      <Avatar v-if="avatarEdit" :info="userInfo.avatar" @Skip="skip" />
    </Modal>
    <!-- 专业信息 -->
    <Modal v-model="majorInfoEdit"
      title="编辑专业信息"
      :mask-closable="false"
      :footer-hide="true"
      width="520">
      <MajorInfo v-if="majorInfoEdit" @Skip="skip" />
    </Modal>
    <!-- 个人基本信息 -->
    <Modal v-model="basicInfoEdit"
      title="编辑个人基本信息"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal"
      width="520">
      <BasicInfo v-if="basicInfoEdit" :info="basicInfo" @Skip="skip" />
    </Modal>
    <!-- 高等教育背景 -->
    <Modal v-model="educationInfoEdit"
      title="编辑高等教育背景"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <EducationInfo v-if="educationInfoEdit" :info="educationInfo" @Skip="skip" />
    </Modal>
    <!-- 奖项荣誉 -->
    <Modal v-model="awardInfoEdit"
      title="编辑奖项荣誉"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <AwardInfo v-if="awardInfoEdit" :info="awardInfo" @Skip="skip" />
    </Modal>
    <!-- 工作履历 -->
    <Modal v-model="experienceInfoEdit"
      title="编辑工作履历"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <ExperienceInfo v-if="experienceInfoEdit" :info="experienceInfo" @Skip="skip" />
    </Modal>
    <!-- 代表作品 -->
    <Modal v-model="workInfoEdit"
      title="编辑代表作品"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="550">
      <WorkInfo v-if="workInfoEdit"  :info="workInfoOne" @Skip="skip" />
    </Modal>
    <!-- 论文著作 -->
    <Modal v-model="paperInfoEdit"
      title="编辑论文著作"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <PaperInfo v-if="paperInfoEdit" :info="paperInfo" @Skip="skip" />
    </Modal>
    <!-- 专业资质 -->
    <Modal v-model="qualificationInfoEdit"
      title="编辑专业资质"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <QualificationInfo v-if="qualificationInfoEdit" :info="qualificationInfo" @Skip="skip" />
    </Modal>
    <!-- 媒体曝光 -->
    <Modal v-model="mediaInfoEdit"
      title="编辑媒体曝光"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <MediaInfo v-if="mediaInfoEdit" :info="mediaInfo" @Skip="skip" />
    </Modal>
    <!-- 社会任职 -->
    <Modal v-model="serviceInfoEdit"
      title="编辑社会任职"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="520">
      <ServiceInfo v-if="serviceInfoEdit" :info="serviceInfo" @Skip="skip" />
    </Modal>
    <!-- 社会活动 -->
    <Modal v-model="activityInfoEdit"
      title="编辑社会活动"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="550">
      <ActivityInfo v-if="activityInfoEdit" :info="activityInfoOne" @Skip="skip" />
    </Modal>
    <!-- 修改密码 -->
    <Modal v-model="isPwd"
      title="修改密码"
      :mask-closable="false"
      :footer-hide="true"
      class-name="myModal largeBtm"
      width="350">
      <ChangePwd v-if="isPwd" @ChangePwdSuccess="changePwd" />
    </Modal>
  </div>
</template>

<script>
import LargeImg from "@/components/form/LargeImg.vue";
import Avatar from "@/components/form/Avatar.vue";
import MajorInfo from "@/components/form/MajorInfo.vue";
import BasicInfo from "@/components/form/BasicInfo.vue";
import EducationInfo from "@/components/form/EducationInfo.vue";
import AwardInfo from "@/components/form/AwardInfo.vue";
import ExperienceInfo from "@/components/form/ExperienceInfo.vue";
import WorkInfo from "@/components/form/WorkInfo.vue";
import PaperInfo from "@/components/form/PaperInfo.vue";
import QualificationInfo from "@/components/form/QualificationInfo.vue";
import MediaInfo from "@/components/form/MediaInfo.vue";
import ServiceInfo from "@/components/form/ServiceInfo.vue";
import ActivityInfo from "@/components/form/ActivityInfo.vue";
import ChangePwd from "@/components/common/ChangePwd.vue";

import personalService from "@/api/personal";
export default {
  name: "PersonalInfo",
  components: {
    LargeImg,
    Avatar,
    MajorInfo,
    BasicInfo,
    EducationInfo,
    AwardInfo,
    ExperienceInfo,
    WorkInfo,
    PaperInfo,
    QualificationInfo,
    MediaInfo,
    ServiceInfo,
    ActivityInfo,
    ChangePwd
  },
  data() {
    return {
      navActiveId: 1,
      isDetail: 1,

      img: "",
      largeImg: false,

      userInfo: {},
      avatarEdit: false,

      majorInfo: {},
      majorInfoEdit: false,

      basicInfo: {},
      basicInfoEdit: false,
      addressLoading: false,
      emailLoading: false,
      weiboLoading: false,
      phoneLoading: false,

      educationInfo: [{}],
      educationInfoEdit: false,
      educationLoading: false,

      awardInfo: [{}],
      awardInfoEdit: false,
      awardLoading: false,

      experienceInfo: [{}],
      experienceInfoEdit: false,
      experienceLoading: false,

      workInfo: [{}],
      workInfoOne: {},
      workInfoEdit: false,
      projectLoading: false,

      paperInfo: [{}],
      paperInfoEdit: false,
      paperLoading: false,

      qualificationInfo: [{}],
      qualificationInfoEdit: false,
      qualificationLoading: false,

      mediaInfo: [{}],
      mediaInfoEdit: false,
      mediaLoading: false,

      serviceInfo: [{}],
      serviceInfoEdit: false,
      serviceLoading: false,

      activityInfo: [{}],
      activityInfoOne: {},
      activityInfoEdit: false,
      activityLoading: false,

      isPwd: false,

      showLargePic: false,
      largePicPath: ""
    };
  },
  mounted() {
    if (this.gIsLogin()) {
      window.addEventListener("scroll", this.handleScroll, true);

      this.userInfo = this.$store.getters.userInfo || {};
      this.nullToFalse();
      let {
        sex,
        nation,
        address,
        email,
        website,
        wechatSubscription,
        weibo,
        video,
        description
      } = this.userInfo;
      this.basicInfo = {
        sex,
        nation,
        address,
        email,
        website,
        wechatSubscription,
        weibo,
        video,
        description
      };

      if (!this.userInfo.avatar) {
        this.avatarEdit = true;
      } else {
        this.getEducationList();
        this.getAwardHonorList();
        this.getExperienceList();
        this.getWorkList();
        this.getPaperList();
        this.getQualificationList();
        this.getMediaList();
        this.getServiceList();
        this.getActivityList();

        let _this = this;
        let timer = setInterval(function() {
          _this.skip({ key: "majorInfo" });
          clearInterval(timer);
        }, 1200);
        setTimeout(function() {
          clearInterval(timer);
        }, 10000);
      }

      // let arr = [{year: 1890, name: 1}, {year: 2489, name: 2}, {year: 1930, name: 3}]
      // console.log(arr.sort(this.sortByDate('year')))
    } else {
      this.$Modal.info({
        title: "提示",
        content: "登录后才能完善个人资料",
        okText: "去登录",
        onOk: () => {
          this.$router.push("/login?fromUrl=/personal_info");
        }
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // 修改密码
    changePwd() {
      this.isPwd = !this.isPwd;
    },
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.push("/login");
    },
    // 获取学历文字
    getEducationText(val) {
      switch (val) {
        case "JUNIORCOLLEGE":
          return "专科";
        case "BACHELOR":
          return "本科";
        case "MASTER":
          return "硕士";
        case "DOCTOR":
          return "博士";
      }
    },
    // 获取工作关系文字
    getWorkRelationText(val) {
      switch (val) {
        case "SUBORDINATE":
          return "下属";
        case "LEADER":
          return "领导";
        case "COLLEAGUE":
          return "同部门同事";
        case "OTHERCOLLEAGUE":
          return "其他部门同事";
        default:
          return "-";
      }
    },
    // 获取版权方文字
    getCopyrightText(val) {
      switch (val) {
        case "SELF":
          return "本人";
        case "COMPANY":
          return "所在单位";
        case "PARTYA":
          return "甲方";
      }
    },
    // 获取设计形式文字
    getTeamTypeText(val) {
      switch (val) {
        case "SELF":
          return "个人";
        case "TEAM":
          return "团队";
        default:
          return "-";
      }
    },
    // 获取状态描述语
    getStatusText(status) {
      if (status == "SUCCESS") {
        return "查验通过";
      }
      if (status == "FAILED") {
        return "！查验未通过，请重新修改";
      }
      return "查验中";
    },
    // 获取教育背景列表信息
    getEducationList() {
      personalService
        .getEducationByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.educationInfo = res.data;
            // if(!this.isValueArr(this.educationInfo)){
            //   this.educationInfoEdit = true
            // }else{
            //   this.skip({key: 'educationInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取奖项荣誉列表信息
    getAwardHonorList() {
      personalService
        .getAwardHonorByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.awardInfo = res.data;
            // if(!this.isValueArr(this.awardInfo)){
            //   this.awardInfoEdit = true
            // }else{
            //   this.skip({key: 'awardInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取工作履历列表信息
    getExperienceList() {
      personalService
        .getExperienceByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.experienceInfo = res.data;
            // if(!this.isValueArr(this.experienceInfo)){
            //   this.experienceInfoEdit = true
            // }else{
            //   this.skip({key: 'experienceInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取作品列表信息
    getWorkList() {
      personalService
        .getProjects({
          "accountId.eq": this.userInfo.accountId,
          sort: "id,desc"
        })
        .then(res => {
          if (res.errorNo == 0) {
            this.workInfo = res.data;
            // if(!this.isValueArr(this.workInfo)){
            //   this.workInfoEdit = true
            // }else{
            //   this.skip({key: 'workInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取论文著作列表信息
    getPaperList() {
      personalService
        .getPaperByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.paperInfo = res.data;
            // if(!this.isValueArr(this.paperInfo)){
            //   this.paperInfoEdit = true
            // }else{
            //   this.skip({key: 'paperInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取专业资质列表信息
    getQualificationList() {
      personalService
        .getQualificationByAccountId({
          "accountId.eq": this.userInfo.accountId
        })
        .then(res => {
          if (res.errorNo == 0) {
            this.qualificationInfo = res.data;
            // if(!this.isValueArr(this.qualificationInfo)){
            //   this.qualificationInfoEdit = true
            // }else{
            //   this.skip({key: 'qualificationInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取媒体曝光列表信息
    getMediaList() {
      personalService
        .getMediaByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.mediaInfo = res.data;
            // if(!this.isValueArr(this.mediaInfo)){
            //   this.mediaInfoEdit = true
            // }else{
            //   this.skip({key: 'mediaInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取社会任职列表信息
    getServiceList() {
      personalService
        .getServiceByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.serviceInfo = res.data;
            // if(!this.isValueArr(this.serviceInfo)){
            //   this.serviceInfoEdit = true
            // }else{
            //   this.skip({key: 'serviceInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取社会活动列表信息
    getActivityList() {
      personalService
        .getActivityByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            this.activityInfo = res.data;
            // if(!this.isValueArr(this.activityInfo)){
            //   this.activityInfoEdit = true
            // }else{
            //   this.skip({key: 'activityInfo'})
            // }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 改变对外显示状态前执行
    beforeChangeOpen(flag, resolve) {
      this[`${flag}Loading`] = true;
      let promise;
      switch (flag) {
        case "education":
          promise = personalService.changeEducationOpen();
          break;
        case "award":
          promise = personalService.changeAwardHonorOpen();
          break;
        case "experience":
          promise = personalService.changeExperienceOpen();
          break;
        case "project":
          promise = personalService.changeProjectOpen();
          break;
        case "paper":
          promise = personalService.changePaperOpen();
          break;
        case "qualification":
          promise = personalService.changeQualificationOpen();
          break;
        case "media":
          promise = personalService.changeMediaOpen();
          break;
        case "service":
          promise = personalService.changeServiceOpen();
          break;
        case "activity":
          promise = personalService.changeActivityOpen();
          break;
        case "address":
          promise = personalService.changeAddressOpen();
          break;
        case "email":
          promise = personalService.changeEmailOpen();
          break;
        case "weibo":
          promise = personalService.changeWeiboOpen();
          break;
        case "phone":
          promise = personalService.changePhoneOpen();
          break;
        default:
          break;
      }
      promise
        .then(res => {
          this[`${flag}Loading`] = false;
          if (res.errorNo == 0) {
            let _this = this;
            setTimeout(function() {
              _this.$store.commit("setUserInfo", _this.userInfo);
            }, 10);
            resolve();
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          this[`${flag}Loading`] = false;
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 改变教育背景对外显示状态前
    beforeChangeEducation() {
      return new Promise(resolve => {
        this.beforeChangeOpen("education", resolve);
      });
    },
    // 改变奖项荣誉对外显示状态前
    beforeChangeAward() {
      return new Promise(resolve => {
        this.beforeChangeOpen("award", resolve);
      });
    },
    // 改变工作履历对外显示状态前
    beforeChangeExperience() {
      return new Promise(resolve => {
        this.beforeChangeOpen("experience", resolve);
      });
    },
    // 改变作品对外显示状态前
    beforeChangeProject() {
      return new Promise(resolve => {
        this.beforeChangeOpen("project", resolve);
      });
    },
    // 改变论文著作对外显示状态前
    beforeChangePaper() {
      return new Promise(resolve => {
        this.beforeChangeOpen("paper", resolve);
      });
    },
    // 改变专业资质对外显示状态前
    beforeChangeQualification() {
      return new Promise(resolve => {
        this.beforeChangeOpen("qualification", resolve);
      });
    },
    // 改变媒体曝光对外显示状态前
    beforeChangeMedia() {
      return new Promise(resolve => {
        this.beforeChangeOpen("media", resolve);
      });
    },
    // 改变社会任职对外显示状态前
    beforeChangeService() {
      return new Promise(resolve => {
        this.beforeChangeOpen("service", resolve);
      });
    },
    // 改变社会活动对外显示状态前
    beforeChangeActivity() {
      return new Promise(resolve => {
        this.beforeChangeOpen("activity", resolve);
      });
    },
    // 改变地址对外显示状态前
    beforeChangeAddress() {
      return new Promise(resolve => {
        this.beforeChangeOpen("address", resolve);
      });
    },
    // 改变邮箱对外显示状态前
    beforeChangeEmail() {
      return new Promise(resolve => {
        this.beforeChangeOpen("email", resolve);
      });
    },
    // 改变微博对外显示状态前
    beforeChangeWeibo() {
      return new Promise(resolve => {
        this.beforeChangeOpen("weibo", resolve);
      });
    },
    // 改变手机对外显示状态前
    beforeChangePhone() {
      return new Promise(resolve => {
        this.beforeChangeOpen("phone", resolve);
      });
    },
    // 将对外展示的字段转化为false
    nullToFalse() {
      this.userInfo.addressOpen = this.userInfo.addressOpen ? true : false;
      this.userInfo.emailOpen = this.userInfo.emailOpen ? true : false;
      this.userInfo.phoneOpen = this.userInfo.phoneOpen ? true : false;
      this.userInfo.weiboOpen = this.userInfo.weiboOpen ? true : false;
    },
    // 查看大图
    openImg(path) {
      // window.open(path, '_blank')
      this.showLargePic = true;
      this.largePicPath = path;
      // this.largeImg = true
      // this.img = path
    },
    // 跳过此页
    skip(data) {
      let flag = data.key;
      this[`${flag}Edit`] = false;
      if (flag == "activityInfo") {
        return;
      }
      if (flag == "serviceInfo") {
        if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "mediaInfo") {
        if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "qualificationInfo") {
        if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "paperInfo") {
        if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "workInfo") {
        if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "experienceInfo") {
        if (!this.isValueArr(this.workInfo)) {
          this.workInfoEdit = true;
        } else if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "awardInfo") {
        if (!this.isValueArr(this.experienceInfo)) {
          this.experienceInfoEdit = true;
        } else if (!this.isValueArr(this.workInfo)) {
          this.workInfoEdit = true;
        } else if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "educationInfo") {
        if (!this.isValueArr(this.awardInfo)) {
          this.awardInfoEdit = true;
        } else if (!this.isValueArr(this.experienceInfo)) {
          this.experienceInfoEdit = true;
        } else if (!this.isValueArr(this.workInfo)) {
          this.workInfoEdit = true;
        } else if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "basicInfo") {
        this.userInfo = this.$store.getters.userInfo;
        this.nullToFalse();
        let {
          sex,
          nation,
          address,
          email,
          website,
          wechatSubscription,
          weibo,
          video,
          description
        } = this.userInfo;
        this.basicInfo = {
          sex,
          nation,
          address,
          email,
          website,
          wechatSubscription,
          weibo,
          video,
          description
        };

        if (!this.isValueArr(this.educationInfo)) {
          this.educationInfoEdit = true;
        } else if (!this.isValueArr(this.awardInfo)) {
          this.awardInfoEdit = true;
        } else if (!this.isValueArr(this.experienceInfo)) {
          this.experienceInfoEdit = true;
        } else if (!this.isValueArr(this.workInfo)) {
          this.workInfoEdit = true;
        } else if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      } else if (flag == "majorInfo") {
        this.avatarEdit = false;
        this.userInfo = this.$store.getters.userInfo;
        this.nullToFalse();
        if (!this.isValueObj(this.basicInfo)) {
          this.basicInfoEdit = true;
        } else if (!this.isValueArr(this.educationInfo)) {
          this.educationInfoEdit = true;
        } else if (!this.isValueArr(this.awardInfo)) {
          this.awardInfoEdit = true;
        } else if (!this.isValueArr(this.experienceInfo)) {
          this.experienceInfoEdit = true;
        } else if (!this.isValueArr(this.workInfo)) {
          this.workInfoEdit = true;
        } else if (!this.isValueArr(this.paperInfo)) {
          this.paperInfoEdit = true;
        } else if (!this.isValueArr(this.qualificationInfo)) {
          this.qualificationInfoEdit = true;
        } else if (!this.isValueArr(this.mediaInfo)) {
          this.mediaInfoEdit = true;
        } else if (!this.isValueArr(this.serviceInfo)) {
          this.serviceInfoEdit = true;
        } else if (!this.isValueArr(this.activityInfo)) {
          this.activityInfoEdit = true;
        }
      }
    },
    // 修改信息
    edit(flag, obj) {
      if (flag == "basicInfo") {
        let {
          sex,
          nation,
          address,
          email,
          website,
          wechatSubscription,
          weibo,
          video,
          description
        } = this.userInfo;
        this.basicInfo = {
          sex,
          nation,
          address,
          email,
          website,
          wechatSubscription,
          weibo,
          video,
          description
        };
      }
      if (flag == "workInfo") {
        if (obj) {
          this.workInfoOne = obj;
        } else {
          this.workInfoOne = {};
        }
      }

      if (flag == "activityInfo") {
        if (obj) {
          this.activityInfoOne = obj;
        } else {
          this.activityInfoOne = {};
        }
      }

      this[`${flag}Edit`] = true;
    },
    //删除教育背景
    deleteEducation(education) {
      this.$Modal.confirm({
        title: "删除教育背景",
        content: "确定要删除 " + education.university + " 的教育背景吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteEducation(education.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除教育背景成功");
                this.getEducationList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除奖项荣誉
    deleteAward(award) {
      this.$Modal.confirm({
        title: "删除奖项荣誉",
        content:
          "确定要删除 " +
          award.year +
          "-" +
          award.awardName +
          " 的奖项荣誉吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteAwardHonor(award.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除奖项荣誉成功");
                this.getAwardHonorList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除工作履历
    deleteExperience(experience) {
      this.$Modal.confirm({
        title: "删除工作履历",
        content: "确定要删除 " + experience.company + " 的工作履历吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteExperience(experience.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除工作履历成功");
                this.getExperienceList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除作品
    deleteWork(work) {
      this.$Modal.confirm({
        title: "删除作品",
        content: "确定要删除作品“" + work.name + "”吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteOneProject(work.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除作品成功");
                this.getWorkList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除论文著作
    deletePaper(paper) {
      this.$Modal.confirm({
        title: "删除论文著作",
        content: "确定要删除论文著作 " + paper.title + " 吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deletePaper(paper.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除论文著作成功");
                this.getPaperList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除专业资质
    deleteQualification(qualification) {
      this.$Modal.confirm({
        title: "删除专业资质",
        content: "确定要删除专业资质 " + qualification.name + " 吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteQualification(qualification.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除专业资质成功");
                this.getQualificationList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除媒体曝光
    deleteMedia(media) {
      this.$Modal.confirm({
        title: "删除媒体曝光",
        content: "确定要删除媒体曝光 " + media.title + " 吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteMedia(media.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除媒体曝光成功");
                this.getMediaList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除社会任职
    deleteService(service) {
      this.$Modal.confirm({
        title: "删除社会任职",
        content:
          "确定要删除 " +
          service.organizationName +
          "-" +
          service.job +
          " 的社会任职吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteService(service.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除社会任职成功");
                this.getServiceList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    //删除社会活动
    deleteActivity(activity) {
      this.$Modal.confirm({
        title: "删除社会活动",
        content: "确定要删除社会活动 " + activity.name + " 吗？",
        onOk: () => {
          // this.$Message.info('Clicked ok');
          personalService
            .deleteActivity(activity.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除社会活动成功");
                this.getActivityList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    // 判断对象是否为空对象 false为空对象
    isValueObj(obj) {
      let flag = false;
      for (var key in obj) {
        if (obj[key] !== null && obj[key] !== "") {
          return true;
        }
      }
      return flag;
    },
    // 判断数组是否为空数组 false为空对象
    isValueArr(arr) {
      let flag = false;
      for (let i = 0, l = arr.length; i < l; i++) {
        let obj = arr[i] || {};
        for (var key in obj) {
          if (obj[key] !== null && obj[key] !== "") {
            return true;
          }
        }
      }
      return flag;
    },
    // 展开信息
    showDetail(flag) {
      this.isDetail = flag;
      let _this = this;
      setTimeout(function() {
        _this.goAnchor(flag);
      }, 10);
    },
    // 计算滚动条位置更新侧边导航栏状态
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      // console.log('s:'+scrollTop)
      let offsetTop2 = this.$refs["2"].offsetTop - 50,
        offsetTop3 = this.$refs["3"].offsetTop - 50,
        offsetTop4 = this.$refs["4"].offsetTop - 50,
        offsetTop5 = this.$refs["5"].offsetTop - 50,
        offsetTop6 = this.$refs["6"].offsetTop - 50,
        offsetTop7 = this.$refs["7"].offsetTop - 50,
        offsetTop8 = this.$refs["8"].offsetTop - 50,
        offsetTop9 = this.$refs["9"].offsetTop - 50,
        offsetTop10 = this.$refs["10"].offsetTop - 50;
      // console.log('s2:'+offsetTop2)
      // console.log('s3:'+offsetTop3)
      // console.log('s4:'+offsetTop4)
      // console.log('s5:'+offsetTop5)
      // console.log('s6:'+offsetTop6)
      // console.log('s7:'+offsetTop7)
      // console.log('s8:'+offsetTop8)
      // console.log('s9:'+offsetTop9)
      // console.log('s10:'+offsetTop10)
      if (scrollTop > offsetTop10) {
        this.navActiveId = 10;
      } else if (scrollTop > offsetTop9) {
        this.navActiveId = 9;
      } else if (scrollTop > offsetTop8) {
        this.navActiveId = 8;
      } else if (scrollTop > offsetTop7) {
        this.navActiveId = 7;
      } else if (scrollTop > offsetTop6) {
        this.navActiveId = 6;
      } else if (scrollTop > offsetTop5) {
        this.navActiveId = 5;
      } else if (scrollTop > offsetTop4) {
        this.navActiveId = 4;
      } else if (scrollTop > offsetTop3) {
        this.navActiveId = 3;
      } else if (scrollTop > offsetTop2) {
        this.navActiveId = 2;
      } else {
        this.navActiveId = 1;
      }
    },
    // 标签滚动
    goAnchor(selector) {
      // if(selector != 'top'){
      //   this.isDetail = selector
      // }
      let top = this.$refs[selector].offsetTop - 50;
      // console.log('go:'+top)
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  },
  computed: {
    // 基本信息完成度
    percentBasic() {
      let obj = this.basicInfo;
      let num = 0;
      for (var key in obj) {
        if (obj[key] !== null && obj[key] !== "") {
          num += 1;
        }
      }
      return Math.round(num / 11 * 100);
    },
    // 整体资料完成度
    percentTotal() {
      let p1 = this.percentBasic;
      let p2 = this.isValueArr(this.educationInfo) ? 100 : 0;
      let p3 = this.isValueArr(this.awardInfo) ? 100 : 0;
      let p4 = this.isValueArr(this.experienceInfo) ? 100 : 0;
      let p5 = this.isValueArr(this.workInfo) ? 100 : 0;
      let p6 = this.isValueArr(this.paperInfo) ? 100 : 0;
      let p7 = this.isValueArr(this.qualificationInfo) ? 100 : 0;
      let p8 = this.isValueArr(this.mediaInfo) ? 100 : 0;
      let p9 = this.isValueArr(this.serviceInfo) ? 100 : 0;
      let p10 = this.isValueArr(this.activityInfo) ? 100 : 0;
      return Math.round(
        (p1 + p2 + p3 + p4 + p5 + p6 + p7 + p8 + p9 + p10) / 10
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.personal {
  padding-top: 50px;
  padding-bottom: 30px;

  &::after {
    content: "";
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e1e3ef;
  }
  .personalContainer {
    padding: 0 100px;
  }

  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background-size: cover;
    text-align: right;
    line-height: 50px;
    z-index: 999;

    &::before {
      content: "";
      position: absolute;
      left: 10%;
      width: 150px;
      top: 0;
      height: 100%;
      background: url(../../assets/logo.png) no-repeat left;
      background-size: contain;
    }

    .navItem {
      display: inline-block;
      padding: 0 15px;
      color: #ffffff;
      position: relative;

      .menuItem {
        width: 100%;
        display: inline-block;
        text-align: center;
      }
    }
    .navActive::after {
      content: "";
      width: 22px;
      border: 1px solid #fff;
      border-radius: 5px;
      position: absolute;
      bottom: 8px;
      left: 50%;
      margin-left: -11px;
    }
  }

  .sideNav {
    position: fixed;
    top: 60px;
    bottom: 20px;
    overflow-y: auto;
    right: 1px;
    width: 100px;
    text-align: right;
    z-index: 999;

    .sideNavItem {
      display: inline-block;
      width: 90%;
      padding-bottom: 36%;
      background: no-repeat;
      background-size: contain;
      cursor: pointer;
      transition: 500ms;
      position: relative;
    }
    .sideNavItemActive,
    .sideNavItem:hover {
      margin-right: 10%;
    }
    .value5::before {
      content: "";
      position: absolute;
      left: -15px;
      top: 3px;
      bottom: 3px;
      width: 15px;
      background: url(/img/p5.png) no-repeat right;
      background-size: contain;
    }
    .value4::before {
      background-image: url(/img/p4.png);
    }
    .value3::before {
      background-image: url(/img/p3.png);
    }
    .value2::before {
      background-image: url(/img/p2.png);
    }
    .value1::before {
      background-image: url(/img/p1.png);
    }

    .nav1 {
      background-image: url(/img/10.png);
    }
    .nav1Active,
    .nav1:hover {
      background-image: url(/img/11.png);
    }
    .nav2 {
      background-image: url(/img/20.png);
    }
    .nav2Active,
    .nav2:hover {
      background-image: url(/img/21.png);
    }
    .nav3 {
      background-image: url(/img/30.png);
    }
    .nav3Active,
    .nav3:hover {
      background-image: url(/img/31.png);
    }
    .nav4 {
      background-image: url(/img/40.png);
    }
    .nav4Active,
    .nav4:hover {
      background-image: url(/img/41.png);
    }
    .nav5 {
      background-image: url(/img/50.png);
    }
    .nav5Active,
    .nav5:hover {
      background-image: url(/img/51.png);
    }
    .nav6 {
      background-image: url(/img/60.png);
    }
    .nav6Active,
    .nav6:hover {
      background-image: url(/img/61.png);
    }
    .nav7 {
      background-image: url(/img/70.png);
    }
    .nav7Active,
    .nav7:hover {
      background-image: url(/img/71.png);
    }
    .nav8 {
      background-image: url(/img/80.png);
    }
    .nav8Active,
    .nav8:hover {
      background-image: url(/img/81.png);
    }
    .nav9 {
      background-image: url(/img/90.png);
    }
    .nav9Active,
    .nav9:hover {
      background-image: url(/img/91.png);
    }
    .nav10 {
      background-image: url(/img/100.png);
    }
    .nav10Active,
    .nav10:hover {
      background-image: url(/img/101.png);
    }
    .top {
      display: block;
      margin: 10px auto 0;
      width: 30%;
      padding-bottom: 30%;
      background: url(/img/top.png) no-repeat center #ffffff;
      background-size: 50%;
      border-radius: 100px;
      cursor: pointer;
    }
  }

  .edit {
    display: inline-block;
    cursor: pointer;
    padding-left: 20px;
    background: url(/img/edit.png) no-repeat left center;
    background-size: 14px;
  }
  .basicWrap {
    background: url(/img/registerBg.jpg) no-repeat;
    background-size: cover;
    border-radius: 5px;
    box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.1);
    margin: 20px 0;
    padding: 50px 100px 50px 200px;
    position: relative;
    min-height: 180px;
    font-size: 12px;

    .txWrap {
      position: absolute;
      left: 100px;
      border-radius: 2px;
      background: #dddddd;
      width: 80px;
      height: 80px;

      .avatarImg {
        width: 100%;
        height: 100%;
      }
      .changeTxBtn {
        position: absolute;
        bottom: -15px;
        left: 50%;
        margin-left: -13px;
        background: linear-gradient(#6fb1fc, #0052d4);
        color: #fff;
        font-size: 20px;
        text-align: center;
        width: 26px;
        height: 26px;
        line-height: 26px;
        border-radius: 100px;
        cursor: pointer;

        .ivu-icon {
          transform: rotate(90deg);
        }
      }
    }
    .realName {
      font-size: 18px;
      padding-bottom: 8px;
    }
    .registerLabel {
      display: inline-block;
      border-radius: 100px;
      padding: 2px 10px;
      background: linear-gradient(to right, #f98b48, #e2497d);
      color: #ffffff;
      margin: 5px 10px 0 0;
    }
    .basicEdit {
      position: absolute;
      right: 20px;
      top: 50px;
      color: #00b7ee;
    }
  }
  .itemWrap {
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;

    .itemTitle {
      position: relative;
      background: url(/img/titleBg.png) no-repeat left center;
      background-size: contain;
      height: 40px;
      line-height: 40px;
      padding: 0 20px 0 30px;
      color: #a2a2a2;

      .titleBtn {
        position: absolute;
        right: 20px;
        top: 0;
        color: #00b7ee;

        .switchText {
          color: #221715;
        }
        .switchBtn {
          margin: 0 30px 0 10px;
        }
      }
      .folder {
        display: inline-block;
        cursor: pointer;
        padding-right: 18px;

        &::after {
          position: absolute;
          right: 0;
          content: "\f116";
          font-family: Ionicons;
        }
      }
    }
    .itemInfo {
      margin: 0 20px;
      padding-bottom: 20px;
      border-top: 1px solid #ebebeb;

      .itemDivider {
        margin-top: 20px;
        border-top: 1px solid #ebebeb;
      }

      .editBtn-div {
        text-align: center;
        color: #00b7ee;
      }

      .delete {
        display: inline-block;
        cursor: pointer;
        margin-left: 20px;
      }

      .content {
        min-height: 21px;
      }

      .label {
        color: #a2a2a2;
        font-size: 12px;
        padding: 15px 0 3px;

        .labelSwitch {
          float: right;
          color: #221715;
          padding-right: 10px;

          .switchBtn {
            margin-left: 10px;
          }
        }
      }
      .imgWrap {
        margin-top: 0;
        margin-bottom: 10px;
      }
      .stateNote {
        display: inline-block;
        border-radius: 100px;
        border: 1px solid #bcbcbc;
        color: #bcbcbc;
        padding: 0 10px;
        margin-left: 10px;
      }
      .addArea {
        padding: 50px 0;
        text-align: center;
      }
    }
  }

  .fixedBottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 10px;
  }
}

@media (max-width: 768px) {
  .personal {
    .personalContainer {
      padding: 0 15px;
    }
    .sideNav {
      display: none;
    }
    .basicWrap {
      padding: 50px 15px 50px 110px;

      .txWrap {
        left: 15px;
      }
    }
  }
}
</style>